import axios from 'axios';
import { Toast } from 'vant';

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API + 'sdm/mtc/',
  // timeout: 5000
})

// 请求拦截
service.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截
service.interceptors.response.use(
  response => response.data,
  error => {
    Toast.fail(error.message);
  }
)

export default service;

